export default __webpack_public_path__ + "38b0ee6446ba88a1dcbda40f27079cea.svg";